import styled from 'styled-components';

export const Toolbar = styled.div<{
  position: {
    x: number;
    y: number;
  };
}>`
  position: fixed;
  left: ${({ position }) => position.x}px;
  top: ${({ position }) => position.y}px;
  z-index: 100;
  transform: translateX(-50%);
`;

export const StyledToolbarContent = styled.div`
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 4px;

  background-color: ${({ theme }) => theme.palette.common.white};
  box-shadow: ${({ theme }) => theme.shadows.dropdown};
`;

export const StyledAiPendingHint = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.grey[500]};
  padding: 0 4px;
`;
